import { render, staticRenderFns } from "./ResultQuestionPreview.vue?vue&type=template&id=2246bba6&"
import script from "./ResultQuestionPreview.vue?vue&type=script&lang=js&"
export * from "./ResultQuestionPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports